import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9ee014e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "station-chart-map",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  style: {"width":"100%","height":"100%"}
}, null, -1))
const _hoisted_3 = { class: "station-chart-map-tip" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总充电能量数(kWh)", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总放电能量数(kWh)", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "年度同比增长率(kWh)", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总设备数", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总站点数", -1))

import * as echarts from 'echarts'
import { onMounted, ref, watch } from 'vue'
import chinaMap from '@/assets/maps/china.json' // Adjust path if needed
import type { GetEssStationGeoStatsReply } from '../types'

export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data?: Partial<GetEssStationGeoStatsReply>
}

const chartMap = ref<echarts.ECharts | null>(null)

onMounted(() => {
  initMap()
})

watch(
  () => props.data,
  (newVal) => {
    if (!chartMap.value) return
    const data = (newVal?.stations ?? []).map((i) => {
      return {
        name: i.name,
        value: [i.lng, i.lat, 100],
      }
    })
    chartMap.value.setOption({
      series: [
        {
          data: data,
        },
      ],
    })
    console.log('stationMap', data)
  },
)
function initMap() {
  const chartDom = document.getElementById('map')
  if (!chartDom) return
  chartMap.value = echarts.init(chartDom)

  // Register the China map
  echarts.registerMap('china', chinaMap as any)

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        // 确保 params.value 存在且是数组
        if (params.value && Array.isArray(params.value) && params.value.length > 2) {
          // return `名称: ${params.name}<br/>充电桩数量: ${params.value[2]}`
          return `名称: ${params.name}`
        }
        return `名称: ${params.name}`
      },
    },
    geo: {
      map: 'china',
      label: {
        emphasis: { show: false },
      },
      roam: false,
      zoom: 1.2,
      itemStyle: {
        normal: {
          areaColor: 'rgba(2,37,101,.5)',
          borderColor: 'rgba(94, 78, 255,.5)',
        },
        emphasis: { areaColor: 'rgba(2,37,101,.8)' },
      },
    },
    series: [
      {
        name: '站点',
        // 1. 将类型从 'scatter' 修改为 'effectScatter'
        type: 'effectScatter',
        coordinateSystem: 'geo',
        data: [], // 您的数据将在这里填充

        // 2. 新增 rippleEffect 配置，用于控制水波纹动画
        rippleEffect: {
          // 动画效果，可选 'stroke' (涟漪) 和 'fill' (波纹)
          brushType: 'stroke',
          // 动画的周期，秒数
          period: 4,
          // 涟漪的最大缩放比例
          scale: 4,
        },

        // 以下是您原有的配置，它们在 effectScatter 中同样有效
        symbolSize: (val) => (val && val.length > 2 ? val[2] / 10 : 5),
        label: {
          normal: {
            formatter: (value) => {
              return ''
            },
            position: 'right',
            show: false,
          },
          emphasis: { show: true },
        },
        itemStyle: {
          // 这是中心标记点的颜色
          normal: { color: '#fa0454' },
        },
      },
    ],
  }
  chartMap.value.setOption(option)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.data?.totalChargeEnergy?.toFixed(0) || 0), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.data?.totalDischargeEnergy?.toFixed(0) || 0), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.data?.yearIncreaseRate || '-'), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.data?.deviceCount || 0), 1),
        _hoisted_7
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.data?.stationCount || 0), 1),
        _hoisted_8
      ])
    ])
  ]))
}
}

})